import { useListasModel } from '../../../modelos/listas/modeloListas';
import React, { useEffect } from 'react'

const AgregarVariables = () => {

    //obtener universidades
    //obtener carreras
    //obtener materias

    const {
                cargarUniversidades,
                cargarCarreras,
                cargarMaterias,
    } = useListasModel();

  useEffect(() =>{
    cargarUniversidades();
    cargarCarreras();
    cargarMaterias();
  }, []);

    
  return (
    <div>
      agregar variables
    </div>
  )
}

export default AgregarVariables
